<template>
    <div class="personal-profile">
        <router-link to="/profile">← back</router-link>
        <div>{{ person.name }}</div>
        <div>{{ person.birthday }}</div>

    </div>    
</template>

<script>
import profileData from '@/data/profile.js'
export default {
    props:['id'],
    data: function() {
        return {
            person: null,
        }
    },
    created: function() {
        const id = Number( this.id );
        for ( const person of profileData ) {
            if ( person.id === id ) {
                this.person = person;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '../assets/global.scss';
</style>

